module.exports = __webpack_public_path__ + "img/Kcorazon.3b48ae82.png";